export const events = {
	ACCORDION_OPENED: "accordion:opened",
	TAB_SWITCHED_TO_MODELS: "tabs:switchedToModels",
	TABS_SWITCHED: "tabs:switched",
	TAB_LOADED: "tab:loaded",
	TAB_ALL_LOADED: "tab:all_loaded",
	COUNTRY_PROMPT_OPENED: "country-prompt-opened",
	OVERVIEW_ACCORDION_OPENED: "overviewAccordion:open",
	search: {
		SEARCH: "search",
		PAGE_CHANGED: "search:pageChanged",
		PARSED_QUERYSTRING: "parsed:queryString",
		FACET_CLICK: "click:facet",
		FACET_CLEAR: "clear:facet",
		FACET_CLEAR_ALL: "clear:facets_all",
		CHANGE_PAGE_SIZE: "change:pageSize",
		CHANGE_DISPLAY_MODE: "change:displayMode",
		SETTING_BROWSER_QUERY: "search:setBrowserQuery",
		QUERY_DATA_MODIFIED: "search:queryModified",
		RENDER: "search:render",
		RENDERED: "search:rendered",
		TOGGLE_LOADER: "search:toggle_loader",
	},
	usedEquipmentProductCategory: {
		categoryClick: "click:usedEquipmentProductCategoryCategoryFacets",
		typeClick: "click:usedEquipmentProductCategoryTypeFacets",
		modelYearClick: "click:usedEquipmentProductCategoryModelYearFacets",
		priceChange: "click:usedEquipmentProductCategoryPriceFacets",
		rangeChange: "change:usedEquipmentProductRangeFacets",
		locationClick: "click:usedEquipmentProductLocationFacets",
		provinceClick: "click:usedEquipmentProductCategoryProvinceFacets",
		sizeClick: "click:usedEquipmentProductCategorySizeFacets",
		clearAllFilters: "click:usedEquipmentProductCategoryCurrentFilters",
		searchLocation: "click:searchLocation",
	},
	/**
	 * @deprecated Use TAB_LOAD_EVENTS instead. This will be removed to allow for reference counting.
	 */
	tabLoadedEvent: function (tab: string) {
		return `${this.TAB_LOADED}_${tab}`;
	},
	TAB_LOAD_EVENTS: {
		productOverview: `tab:loaded_overview`,
	} satisfies Record<string, `tab:loaded_${string}`>,
} as const;
